import { Box } from '@mui/material';
import { FC, PropsWithChildren, ReactNode } from 'react';
import { Body2, Label2 } from '../../../typography/TextStyles';
import { TextProps } from '../../../typography/model/TextProps';
import { InfoIconTooltip } from '../../tooltip/InfoIconTooltip';

type Props = PropsWithChildren & {
  textProps?: TextProps;
  tooltipTitle?: ReactNode;
  noWrap?: boolean;
  componentVariant?: 'label2' | 'body2';
};

export const ListTextColTitle: FC<Props> = ({
  textProps,
  noWrap = true,
  tooltipTitle,
  componentVariant = 'label2',
  children,
}) => {
  const Component = componentVariant === 'label2' ? Label2 : Body2;

  const title = (
    <Component
      width="min-content"
      justifyItems="center"
      alignItems="center"
      fontWeight={componentVariant === 'label2' ? 500 : 400}
      noWrap={noWrap}
      display={noWrap ? 'contents' : 'block'}
      {...textProps}
    >
      {children}
    </Component>
  );

  return (
    <Box display="flex" alignItems="center" flexWrap="nowrap">
      {title}
      {tooltipTitle && <InfoIconTooltip title={tooltipTitle} />}
    </Box>
  );
};
